<template>
  <ux-form
    class="debugg-view x-border-50 x-margin x-height-100 x-scrollbar-show"
    width="auto"
    ref="form"
    :hideBtn="true"
    :data="formData"
    @confirm="confirm"
    :hideClose="true"
    :colon="true"
    :confirmText="$t('HT.options.env2')"
    :rules="rules"
    label-width="70px"
    data-automation="debugg"
  >
    <div class="form-left">
      <!-- 选择API start -->
      <ux-form-item label="API" prop="apiId">
        <ux-input v-model="productFormInfo.name" size="small" readonly></ux-input>
      </ux-form-item>
      <!-- 选择API end -->
      <!-- 选择环境 start -->
      <ux-form-item v-if="apiFlag" :label="$t('HT.addAccessApi.evn')" required prop="env">
        <ux-select
          v-model="formData.env"
          :options="envList"
          clearable
          value="value"
          label="label"
          @change="getEnv"
        ></ux-select>
      </ux-form-item>
      <!-- 选择环境 end -->
      <ux-form-item
        v-if="productFlag || envInfo"
        :label="$t('HT.debug3.method')"
        :optionText="false"
      >
        <span class="info-method">{{ productFormInfo.request_vo.method }}</span>
      </ux-form-item>
      <!-- 域名 start -->
      <ux-form-item
        v-if="productFlag || envInfo"
        :label="$t('HT.debug3.domain')"
        prop="domain"
        :optionText="false"
      >
        <span class="info-protocol">{{ productFormInfo.protocol }}://</span>
        <!-- <span class="info-protocol">{{productDomains[0]}}</span> -->
        <ux-select
          v-if="apiFlag"
          @change="getDomainInfo"
          class="x-flex-one"
          v-model="formData.domain"
          clearable
          :options="domainUrl"
          value="value"
          label="value"
        ></ux-select>
        <ux-select
          v-else
          @change="getDomaindata"
          class="x-flex-one"
          v-model="formData.domain"
          clearable
          :options="domainUrl"
          value="value"
          label="value"
        ></ux-select>
        <span class="info-protocol">{{ productFormInfo.request_vo.uri }}</span>
      </ux-form-item>
      <!-- 域名 end -->
      <!-- 安全认证 start -->
      <ux-form-item :label="$t('HT.debug1.certification')" required prop="safety.type">
        <ux-select
          v-model="formData.safety.type"
          label="label"
          value="value"
          clearable
          :options="safeList"
        ></ux-select>
      </ux-form-item>
      <template v-if="formData.safety.type == 'APP'">
        <ux-form-item :label="$t('HT.debug3.appList')" :option="false" prop="safety.APPList">
          <ux-select
            class="pro-ipt"
            v-model="formData.safety.APPList"
            label="label"
            value="value"
            :options="appList"
            @change="onchange"
          ></ux-select>
        </ux-form-item>
        <ux-form-item
          label="AppCode"
          :option="false"
          prop="safety.AppCode"
          v-if="formData.safety.APPList"
        >
          <ux-input
            class="pro-ipt"
            v-model="formData.safety.AppCode"
            size="small"
            readonly
            :maxlength="50"
            :placeholder="$t('HT.pleaseInput')"
          ></ux-input>
        </ux-form-item>
        <ux-form-item
          label="AppKey"
          :option="false"
          prop="safety.AppKey"
          v-if="formData.safety.APPList"
        >
          <ux-input
            class="pro-ipt"
            v-model="formData.safety.AppKey"
            size="small"
            readonly
            :maxlength="50"
            :placeholder="$t('HT.pleaseInput')"
          ></ux-input>
        </ux-form-item>
        <ux-form-item
          label="AppSecret"
          :option="false"
          prop="safety.AppSecret"
          v-if="formData.safety.APPList"
        >
          <ux-input
            class="pro-ipt"
            v-model="formData.safety.AppSecret"
            size="small"
            readonly
            :maxlength="50"
            type="password"
            :placeholder="$t('HT.pleaseInput')"
          ></ux-input>
        </ux-form-item>
      </template>
      <!-- 安全认证 end -->
      <!-- Path  start-->
      <ux-form-item v-if="pathCount > 0" label="Path" start>
        <div v-for="(item, index) in productFormInfo.request_vo.parameters" class="item-requst">
          <div class="x-flex-align x-margin-b" v-if="item.position === 'Path'" :key="index">
            <ux-input
              v-model="productFormInfo.request_vo.parameters[index].name"
              size="small"
              readonly
            ></ux-input>
            <span class="x-margin-x">=</span>
            <ux-input
              v-model="path[item.name]"
              size="small"
              :placeholder="item.required ? $t('HT.required') : ''"
            ></ux-input>
          </div>
        </div>
      </ux-form-item>
      <!-- Path  end-->
      <!-- Header 透传 start -->
      <ux-form-item label="Header" start>
        <div v-for="(item, index) in header_throuth" class="item-requst">
          <div class="x-flex-align x-margin-b" :key="index">
            <ux-input v-model="header_throuth[index][0]" size="small"></ux-input>
            <span class="x-margin-x">=</span>
            <ux-input v-model="header_throuth[index][1]" size="small"></ux-input>
            <ux-button
              class="add-button"
              v-if="index == 0"
              type="primary"
              icon="ux_icon_plus"
              @click="addHeaders"
            ></ux-button>
            <ux-button
              class="add-button"
              v-else
              type="primary"
              icon="ux_icon_less"
              @click="delHeaders(index)"
            ></ux-button>
          </div>
        </div>
      </ux-form-item>
      <!-- Header 透传 end -->
      <!-- Query 透传 start-->
      <ux-form-item label="Query" start class="item-option">
        <div v-for="(item, index) in query_throuth" class="item-requst">
          <div class="x-flex-align x-margin-b" :key="index">
            <ux-input v-model="query_throuth[index][0]" size="small"></ux-input>
            <span class="x-margin-x">=</span>
            <ux-input v-model="query_throuth[index][1]" size="small"></ux-input>
            <ux-button
              class="add-button"
              v-if="index == 0"
              type="primary"
              icon="ux_icon_plus"
              @click="addQuerys"
            ></ux-button>
            <ux-button
              class="add-button"
              v-else
              type="primary"
              icon="ux_icon_less"
              @click="delQuerys(index)"
            ></ux-button>
          </div>
        </div>
      </ux-form-item>
      <!-- Query 透传 end-->
      <!-- Body 透传 start-->
      <ux-form-item label="Body" start class="item-option">
        <div v-for="(item, index) in body_throuth" class="item-requst">
          <div class="x-flex-align x-margin-b" :key="index">
            <ux-input v-model="body_throuth[index][0]" size="small"></ux-input>
            <span class="x-margin-x">=</span>
            <ux-input v-model="body_throuth[index][1]" size="small"></ux-input>
            <ux-button
              class="add-button"
              v-if="index == 0"
              type="primary"
              icon="ux_icon_plus"
              @click="addBodys"
            ></ux-button>
            <ux-button
              class="add-button"
              v-else
              type="primary"
              icon="ux_icon_less"
              @click="delBodys(index)"
            ></ux-button>
          </div>
        </div>
      </ux-form-item>
      <!-- Body 透传 end-->
    </div>
    <div class="form-right">
      <!-- <ux-form-item start prop="reponse" bottom="20px" class="debug-textarea">
            </ux-form-item> -->
      <div class="debug-textarea">
        <div class="debug-msg">{{ $t('HT.debug3.msg') }}</div>
        <my-footer-btn
          spacing="80px"
          padding="0px"
          hideClose
          :confirmText="$t('HT.options.env2')"
          @confirm="confirm"
        ></my-footer-btn>
      </div>
      <div v-if="!req && errVal.length == 0" class="msg_show"></div>
      <div v-if="req" :class="req ? 'msg_show' : ''">
        <div>
          <span>Request: </span>
          <div v-for="(item, index) in reqVal" :key="index">
            <!-- <p>{{item.join(': ') }}</p> -->
            <span>{{ item[0] }}</span>
            <span>: </span>
            <span>{{ item[1] }}</span>
          </div>
        </div>
        <div class="resp_info">
          <span>Response: </span>
          <div v-for="(item, index) in respVal" :key="index">
            <!-- <p>{{item.join(': ')}}</p> -->
            <span>{{ item[0] }}</span>
            <span>: </span>
            <span>{{ item[1] }}</span>
          </div>
        </div>
      </div>
      <div v-if="errVal.length > 0" :class="errVal.length > 0 ? 'err_show' : ''">
        <div>
          <div v-for="(item, index) in errVal" :key="index">
            <p>{{ item.join(': ') }}</p>
          </div>
        </div>
      </div>
    </div>
  </ux-form>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        apiId: '', // API id
        env: '', // 环境
        apiGroup: '', //API分组
        domain: '', //域名列表
        safety: {
          //选择认证
          type: '',
          AppCode: '',
          AppKey: '',
          AppSecret: '',
          APPList: ''
        },
        params: {
          Path: '',
          Header: '',
          Query: ''
        },
        mapping: {
          Path: '',
          Header: '',
          Query: ''
        }
      },
      path: {}, // 发送参数
      header: {}, // 发送参数
      query: {}, // 发送参数
      body: {}, // 发送参数
      body_throuth: [[]], // 发送参数
      query_throuth: [[]], // 发送参数
      header_throuth: [[]], // 发送参数
      apiList: [], // API列表
      info: {}, // API 详情
      response: '', // 响应
      apiGroupList: [], //api分组
      rules: this.$rul.testApi2(),
      headerList: [1],
      envList: [], // 可选环境
      domainUrl: [], //域名列表
      domainInfo: '', //选中的域名,
      envInfo: '', //选中的环境
      flag: false,
      params: [],
      queryCount: 0, //用于Query的显示和隐藏
      headerCount: 0, //用于Header的显示和隐藏
      pathCount: 0, //用于Path的显示和隐藏
      productFormInfo: JSON.parse(this.$route.query.params),
      productFlag: this.$route.query.flag, //产品总览flag 用于判断展示
      apiFlag: this.$route.query.apiFlag, //api列表flag
      productDomains: [],
      safeList: [], //安全认证列表
      appList: [], //选择应用列表
      appData: {}, //appcode、app_key、app_secret
      req: '', //request
      resp: '', //response
      reqVal: [], //请求信息
      respVal: [], //响应信息
      errVal: [] //错误信息
    };
  },
  computed: {
    safetyList() {
      return this.formData.safety;
    }
  },
  watch: {
    safetyList: {
      handler(val) {
        this.flag = true;
        this.formData.safety = val;
      }
      // deep: true
    }
  },
  methods: {
    onchange(data) {
      const arr = data.split(',');
      this.formData.safety.AppCode = arr[0];
      this.formData.safety.AppKey = arr[1];
      this.formData.safety.AppSecret = arr[2];
    },
    /**
     * 获取应用列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.apply.getList(params).then((res) => {
        if (res.code == 10000) {
          this.appList = res.data.map((item) => {
            return {
              label: item.name,
              value: [item.app_code, item.app_key, item.app_secret].join(',')
            };
          });
        }
      });
    },
    // 获取环境
    getEnv(env) {
      this.envInfo = env;
      this.changeDomainUrl(this.productFormInfo.domains);
    },
    // 获取选择的域名
    getDomainInfo(domainString) {
      this.domainInfo = domainString;
    },
    // 获取选择的域名
    getDomaindata(domainString) {
      this.domainInfo = domainString;
    },
    //用于是否展示query header path
    handlerParams(val) {
      this.queryCount = this.headerCount = this.pathCount = 0;
      for (let item of val) {
        if (item.position == 'Query') {
          this.queryCount++;
        } else if (item.position == 'Header') {
          this.headerCount++;
        } else if (item.position == 'Path') {
          this.pathCount++;
        }
      }
    },
    /**
     * 测试发送请求
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let config = {
            config: true
          };
          let myquery = {};
          let myheader = {};
          let mybody = {};
          if (this.query_throuth[0].length > 0) {
            for (let i = 0; i < this.query_throuth.length; i++) {
              myquery[this.query_throuth[i][0]] = this.query_throuth[i][1];
            }
          }
          if (this.header_throuth[0].length > 0) {
            for (let i = 0; i < this.header_throuth.length; i++) {
              myheader[this.header_throuth[i][0]] = this.header_throuth[i][1];
            }
          }
          if (this.body_throuth[0].length > 0) {
            for (let i = 0; i < this.body_throuth.length; i++) {
              mybody[this.body_throuth[i][0]] = this.body_throuth[i][1];
            }
          }
          let mybodys = { ...mybody, ...this.body }; //拿到所有query
          let myparameters = { ...myquery, ...this.query }; //拿到所有query
          let mypaths = { ...this.path }; //拿到所有path
          let myheaders = { ...myheader, ...this.header }; //拿到所有header
          let splitHeaders = {};
          let splitBody = {};
          let splitQuery = {};
          let splitPath = {};
          let fullHeaders = Object.entries(myheaders);
          let fullQuery = Object.entries(myparameters);
          let fullBody = Object.entries(mybodys);
          let fullPath = Object.entries(mypaths);

          for (let i = 0; i < fullHeaders.length; i++) {
            //去除没有填值的对象
            if (fullHeaders[i][0] && fullHeaders[i][0] !== 'undefined' && fullHeaders[i][1]) {
              splitHeaders[fullHeaders[i][0]] = fullHeaders[i][1];
            }
          }
          for (let i = 0; i < fullBody.length; i++) {
            //去除没有填值的对象
            if (fullBody[i][0] && fullBody[i][0] !== 'undefined' && fullBody[i][1]) {
              splitBody[fullBody[i][0]] = fullBody[i][1];
            }
          }
          for (let i = 0; i < fullQuery.length; i++) {
            //去除没有填值的对象
            if (fullQuery[i][0] && fullQuery[i][0] !== 'undefined' && fullQuery[i][1]) {
              splitQuery[fullQuery[i][0]] = fullQuery[i][1];
            }
          }
          for (let i = 0; i < fullPath.length; i++) {
            //去除没有填值的对象
            if (fullPath[i][0] && fullPath[i][0] !== 'undefined' && fullPath[i][1]) {
              splitPath[fullPath[i][0]] = fullPath[i][1];
            }
          }

          myheaders = splitHeaders;
          myparameters = splitQuery;
          mypaths = splitPath;
          mybodys = splitBody;

          const postData = {
            //请求参数
            url: `${this.productFormInfo.protocol}://${this.domainInfo}${this.productFormInfo.request_vo.uri}`,
            env: !this.apiFlag ? 'RELEASE' : this.envInfo,
            app_code: this.formData.safety.AppCode || null,
            app_key: this.formData.safety.AppKey || null,
            app_secret: this.formData.safety.AppSecret || null,
            parameters: myparameters,
            paths: mypaths,
            headers: myheaders
          };
          if (Object.keys(mybodys).length > 0) {
            postData.body = mybodys;
          }
          this.test(postData, this.productFormInfo.id, config);
        }
      });
    },
    /**
     * API 调试
     * @param {Object} params 参数对象
     * @param {Object} config 请求config
     */
    test(params, apiId, config) {
      this.$uxLoading.show();
      this.$api.api
        .test(params, apiId, config)
        .then((res) => {
          this.errVal = [];
          // 对响应信息进行处理
          this.req = Object.entries(res.data)[0][0];
          this.resp = Object.entries(res.data)[1][0];
          this.reqVal = Object.entries(Object.entries(res.data)[0][1]);
          this.respVal = Object.entries(Object.entries(res.data)[1][1]);
        })
        .catch((err) => {
          this.req = '';
          this.errVal = Object.entries(err.response.data);
        });
    },
    // 将domainUrl改变成对象数组 api列表的调试
    changeDomainUrl(domains) {
      // this.domainUrl = domains
      this.domainUrl = [];
      this.formData.domain = '';
      for (let i = 0; i < domains.length; i++) {
        // 根据所选环境筛选所需的域名列表
        if (domains[i]?.envs?.includes(this.envInfo)) {
          this.domainUrl.push({ domain: domains[i].domain });
        }
      }
      this.domainUrl = this.domainUrl.map((item) => {
        return {
          label: item.domain,
          value: item.domain
        };
      });
    },
    // 将domainUrl改变成对象数组 产品总览的调试
    getDomainmsg(domains) {
      this.domainUrl = [];
      for (let i = 0; i < domains.length; i++) {
        this.domainUrl.push({ domain: domains[i] });
      }
      this.domainUrl = this.domainUrl.map((item) => {
        return {
          label: item.domain,
          value: item.domain
        };
      });
    },
    /**
     * 添加Querys
     */
    addQuerys() {
      this.query_throuth.push([]);
    },
    /**
     * 添加Bodys
     */
    addBodys() {
      this.body_throuth.push([]);
    },
    /**
     * 添加Header
     */
    addHeaders() {
      this.header_throuth.push([]);
    },
    /**
     * 删除Querys
     */
    delQuerys(index) {
      this.query_throuth.splice(index, 1);
    },
    /**
     * 删除Bodys
     */
    delBodys(index) {
      this.body_throuth.splice(index, 1);
    },
    /**
     * 删除Headers
     */
    delHeaders(index) {
      this.header_throuth.splice(index, 1);
    },
    changeEnv() {
      //环境列表 转换成ux-select所需的字段
      this.envList =
        this.productFormInfo.states &&
        this.productFormInfo.states.map((item) => {
          return {
            label: this.$opt.switchStr(item.env, this.$opt.env2),
            value: item.env
          };
        });
    },
    changeSafeList() {
      //安全认证列表 转换成ux-select所需的字段
      if (this.productFormInfo.safety_certification) {
        this.safeList.push({
          label: this.$opt.switchStr(
            this.productFormInfo.safety_certification.type,
            this.$opt.safeList
          ),
          value: this.productFormInfo.safety_certification.type
        });
      }
    },
    handlePatherArr(data) {
      //处理Path
      const pArr = data.filter((item) => item.position === 'Path');
      for (let item of pArr) {
        this.$set(this.path, item.name, item.default_value);
      }
    },
    handleQueryArr(data) {
      //处理query
      const qArr = data.filter((item) => item.position === 'Query');
      for (let i = 0; i < qArr.length; i++) {
        this.query_throuth.push([]);
        this.query_throuth[i][0] = qArr[i].name;
        this.query_throuth[i][1] = qArr[i].default_value;
      }
      if (this.query_throuth.length > 1) this.query_throuth.pop();
    },
    handleBodyArr(data) {
      //处理Body
      const bArr = data.filter((item) => item.position === 'Body');
      for (let i = 0; i < bArr.length; i++) {
        this.body_throuth.push([]);
        this.body_throuth[i][0] = bArr[i].name;
        this.body_throuth[i][1] = bArr[i].default_value;
      }
      if (this.body_throuth.length > 1) this.body_throuth.pop();
    },
    handleHeaderArr(data) {
      //处理header
      const hArr = data.filter((item) => item.position === 'Header');
      for (let i = 0; i < hArr.length; i++) {
        this.header_throuth.push([]);
        this.header_throuth[i][0] = hArr[i].name;
        this.header_throuth[i][1] = hArr[i].default_value;
      }
      if (this.header_throuth.length > 1) this.header_throuth.pop();
    }
  },
  created() {
    this.getList(this.filter); //获取应用列表
    this.productDomains = this.productFormInfo.domains;
    this.handleQueryArr(this.productFormInfo.request_vo.parameters);
    this.handleBodyArr(this.productFormInfo.request_vo.parameters);
    this.handleHeaderArr(this.productFormInfo.request_vo.parameters);
    this.handlePatherArr(this.productFormInfo.request_vo.parameters);
    this.changeEnv();
    this.changeSafeList();
    // this.handleQuery(this.productFormInfo.request_vo.parameters);
    this.getDomainmsg(this.productFormInfo.domains);
    this.handlerParams(this.productFormInfo.request_vo.parameters);
    this.formData.mapping.Query = this.formData.mapping.Query.split(',');
    this.formData.mapping.Header = this.formData.mapping.Header.split(',');
    this.formData.mapping.Path = this.formData.mapping.Path.split(',');
  }
};
</script>
<style lang="scss" scoped>
.debugg-view {
  box-sizing: border-box;
  padding: 20px 30px 20px 30px;

  .input-width {
    width: 300px;
  }
  .inputSelect-width {
    width: 251px;
  }
  .input-width-parm {
    width: 70%;
  }
  .input-width-p {
    width: 70%;
  }
  .add-button {
    margin-left: 10px;
  }
  .info-method {
    margin-right: 30px;
    color: #777f8f;
  }
  .info-protocol {
    color: #777f8f;
    margin-right: 3px;
  }
}
</style>
<style lang="scss">
.debugg-view {
  display: flex;
  flex: 1;

  .right-item {
    flex-wrap: wrap;
  }

  .form-left {
    flex: 1;
    max-width: 500px;
    min-width: 300px;
    box-sizing: border-box;
    padding-right: 40px;
  }
  .form-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .select {
    width: 15%;
  }
  .item-requst {
    width: 100%;
  }
  .safe-input {
    width: 40%;
  }
  .pro-ipt {
    width: 70%;
  }
  .debug-textarea {
    display: flex;
    margin-bottom: 15px;

    .debug-msg {
      padding: 0 15px;
      font-size: 12px;
      height: 28px;
      background-color: #546478;
      color: #ffff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      border-radius: 5px;
    }
  }
  .msg_show {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0 10px 3px;
    border-radius: 5px;
    background-color: black;
    color: #ffff;
    .resp_info {
      margin-top: 20px;
    }
  }
  .err_show {
    width: 100%;
    height: 70%;
    border-radius: 5px;
    // border: 1px solid #ccc;
    background-color: black;
    padding: 10px 0 10px 3px;
    color: #ffff;
  }
}
</style>
